import { InputNumber } from 'antd';
import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const AdjustContainer = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateAreas: '"start center end"',
  justifyItems: 'center',
  margin: '10rem',
  padding: '3rem',
  backgroundColor: theme.palette.desertSand,
  borderRadius: '20rem',

  color: theme.palette.raisinBlack,
  fontWeight: 700,

  '.start': {
    gridArea: 'start',
    justifySelf: 'flex-start',
  },

  '.center': {
    gridArea: 'center',
  },

  '.end': {
    gridArea: 'end',
    justifySelf: 'flex-end',
  },
}));

export const AdjustBtn = styled(CommonButton)(({ theme }) => ({
  height: '18rem',
  paddingBlock: 0,
  paddingInline: '20rem',
  border: 'none',
  backgroundColor: theme.palette.desertSand,

  '&[data-can-edit="true"]': {
    height: '100%',
  },
}));

export const AddBtnAlone = styled(AdjustBtn)({
  height: '24rem',
  width: '65rem',
  marginLeft: 'auto',
  paddingInline: '10rem',

  fontWeight: 700,
});

export const InputNumberField = styled(InputNumber)`
  input {
    text-align: center !important;
  }

  &.ant-input-number {
    width: auto !important;
  }
`;
